import React from 'react';
import { HiShare } from "react-icons/hi2"; // Pastikan install react-icons/hi2 atau ganti SVG manual

const ShareButton = ({ item, user, compact = false, className = '' }) => {
    // Jika user belum login, tidak bisa share (karena butuh ID referral)
    // Atau bisa juga share tanpa ID (tapi rugi poin)
    if (!user) return null;

    const handleShare = async (e) => {
        e.stopPropagation(); // Biar gak trigger klik card/modal

        // Base URL (sesuaikan dengan domain produksi nanti)
        // Saat dev local: http://localhost:3000
        // Saat prod: https://semestacafe.web.app
        const baseUrl = window.location.origin;

        // Format Link: domain?ref=USER_ID&item=ITEM_ID
        // Deep link ke item agar saat dibuka langsung muncul modal menu tsb
        const shareUrl = `${baseUrl}?ref=${user.uid}${item ? `&item=${item.id || item.itemId}` : ''}`;

        const shareData = {
            title: `Cobain ${item.name} di Semesta Cafe!`,
            text: `Rekomendasi nih: ${item.name}. Enak banget! Cek di sini:`,
            url: shareUrl,
        };

        try {
            // Cek apakah browser support Native Share API (Chrome Android, Safari iOS)
            if (navigator.share) {
                await navigator.share(shareData);
                console.log('Shared successfully');
            } else {
                // Fallback untuk Desktop: Copy Link
                await navigator.clipboard.writeText(`${shareData.text} ${shareData.url}`);
                alert('Link referral berhasil disalin! Kirim ke temanmu ya.');
            }
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };

    if (compact) {
        return (
            <button
                onClick={handleShare}
                className={`flex items-center justify-center bg-white/90 text-green-700 hover:text-green-900 rounded-full p-2 shadow-sm hover:shadow-md transition-all ${className}`}
                title="Bagikan & Dapat Cuan"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="18" cy="5" r="3"></circle>
                    <circle cx="6" cy="12" r="3"></circle>
                    <circle cx="18" cy="19" r="3"></circle>
                    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                </svg>
            </button>
        );
    }

    return (
        <button
            onClick={handleShare}
            className={`flex items-center space-x-1 text-green-700 bg-green-50 hover:bg-green-100 px-3 py-1 rounded-full text-xs font-semibold transition-colors border border-green-200 ${className}`}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="18" cy="5" r="3"></circle>
                <circle cx="6" cy="12" r="3"></circle>
                <circle cx="18" cy="19" r="3"></circle>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
            </svg>
            <span>Share & Cuan</span>
        </button>
    );
};

export default ShareButton;
